import * as Actions from '../actions/actions';
import h from 'virtual-dom/h';
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {VNode} from "virtual-dom";
import {Dictionary} from "../../../../types/rendering";


export default class Renderers
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getRender()
    {
        return (): VNode =>
        {
            const { minimize } = this._settings.accessibility.aria;
            const { minimizeWindowTitleText } = this._settings.textConstants;

            const parameters = {
                className: this._settings.classNames.minimizeClassName,
                title: minimizeWindowTitleText,
                disabled: this.shouldDisable(),
                attributes:{
                  type: 'button',
                  'aria-label': minimize,
                },
                onclick: this.buildMinimizeOnClick(),
            };

            const role = this._settings.accessibility.role.minimize;
            if (role !== "REMOVE")
            {
                (parameters.attributes as Dictionary).role = role;
            }

            return h('button', parameters, []);
        };
    }

    getMutate()
    {
        return (parameters: Dictionary): Dictionary =>
        {
            const { Base, IsMinimized } = this._settings.stateLocations.Window;

            if (!this._store?.getState()[Base][IsMinimized]) { return parameters; }

            const styles = (parameters.style as Dictionary) ?? {};

            return { ...parameters, style: { ...styles, display: "none" } };

        };
    }

    //#endregion



    //#region Helper Methods

    buildMinimizeOnClick()
    {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return (e: Event): boolean =>
        {
            const { IsMinimized } = this._settings.stateLocations.Window;
            const { reportingEventRequest } = this._settings.messageConstants;

            this._store?.dispatch(Actions.setMinimize(true, IsMinimized));

            const input = {
                eventName: 'MinimizedClicked',
                eventValue: true,
                messageType: reportingEventRequest,
            };

            sendRequest(input);

            return false;
        };
    }

    shouldDisable(): boolean
    {
        const { Base, MinimizeButton } = this._settings.stateLocations.Window;

        return this._store?.getState()[Base][MinimizeButton.Base][MinimizeButton.shouldDisable] ?? false;
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-minimize/src/renderers/renderers.ts